<div style="display: flex; width: 300px;">
  <input type="text" id="couponcode" class="form-control m-input" 
    placeholder="" style="width: 150px; padding-right:40px" 
    [(ngModel)]="couponCode" [disabled]="isDisabled"
    (ngModelChange)="this.couponCodeUpdate.next($event)">
  <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="Have a CUE Audio promo code? Enter it here.">
  <img *ngIf="couponValid === true" src="../../assets/app/media/img/icons/checked.svg" class="coupon-validity-icon">
  <img *ngIf="couponValid === false" src="../../assets/app/media/img/icons/x-mark.svg" class="coupon-validity-icon">
</div>